import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_PROJECT_LOCATIONS_SUCCESS = 'GET_PROJECT_LOCATIONS_SUCCESS'
export const GET_PROJECT_LOCATIONS_FAILURE = 'GET_PROJECT_LOCATIONS_FAILURE'

// -- CREATE
export const CREATE_PROJECT_LOCATION_SUCCESS = 'CREATE_PROJECT_LOCATION_SUCCESS'
export const CREATE_PROJECT_LOCATION_FAILURE = 'CREATE_PROJECT_LOCATION_FAILURE'

// -- UPDATE
export const UPDATE_PROJECT_LOCATION_SUCCESS = 'UPDATE_PROJECT_LOCATION_SUCCESS'
export const UPDATE_PROJECT_LOCATION_FAILURE = 'UPDATE_PROJECT_LOCATION_FAILURE'

// -- DELETE
export const DELETE_PROJECT_LOCATION_SUCCESS = 'DELETE_PROJECT_LOCATION_SUCCESS'
export const DELETE_PROJECT_LOCATION_FAILURE = 'DELETE_PROJECT_LOCATION_FAILURE'

// -- SEARCH
export const SEARCH_PROJECT_LOCATIONS = 'SEARCH_PROJECT_LOCATIONS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a project location attribute based on its name.
 *
 * @param {string} term Text to be searched within the project location.
 * @returns {Promise<array<object>>}
 */
export const searchProjectLocations = (term) => async (dispatch) => {
  dispatch({
    type: SEARCH_PROJECT_LOCATIONS,
    data: term
  })
}

/**
 * GET the list of all the locations that belong to a specific project.
 * @param {uuid} pid Project ID
 * @returns {Promise<array<object>>}
 */
export const getProjectLocations = (pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_LOCATION_LIST, { pid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.getProjectLocations()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_PROJECT_LOCATIONS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_PROJECT_LOCATIONS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a project location.
 *
 * @param {object} newLocation New location to be created.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const createProjectLocation = (newLocation, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_LOCATION_CREATE, { pid })
  const api = new Api(path)
  const result = await api.create(newLocation)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.createProjectLocation()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_PROJECT_LOCATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_PROJECT_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific project location attribute.
 *
 * @param {object} newLocation Location object that will replace the previous one.
 * @param {uuid} lid Project location ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const updateProjectLocation = (newLocation, lid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_LOCATION_UPDATE, { pid, lid })
  const api = new Api(path)
  const result = await api.update(newLocation)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.updateProjectLocation()', { newLocation, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_PROJECT_LOCATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_PROJECT_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific project location.
 *
 * @param {uuid} lid Project location ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const deleteProjectLocation = (lid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_LOCATION_DELETE, { pid, lid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.deleteProjectLocation()', { result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_PROJECT_LOCATION_SUCCESS,
      data: lid
    })
  }

  return dispatch({
    type: DELETE_PROJECT_LOCATION_FAILURE,
    data: result.data
  })
}
